import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateQuestionRequest,
  CreateQuestionResponse,
  GetQuestionRequest,
  GetQuestionResponse,
  ListQuestionsRequest,
  ListQuestionsResponse,
  SearchQuestionRequest,
  SearchQuestionResponse,
  UpdateQuestionRequest,
  UpdateQuestionResponse,
} from 'src/types/helios/Question';

export const questionService = {
  // Get all questions
  getAll: (data: ListQuestionsRequest) => {
    return apiClient.get<ListQuestionsResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTIONS.ALL(
          data.programId,
          data.businessUnit,
          data.divisionName,
        ),
      ),
      data,
    );
  },

  getById: (data: GetQuestionRequest) => {
    return apiClient.get<GetQuestionResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTIONS.BY_ID(
          data.programId,
          data.businessUnit,
          data.divisionName,
          data.questionId,
        ),
      ),
      data,
    );
  },

  searchQuestions: (data: SearchQuestionRequest) => {
    return apiClient.post<SearchQuestionResponse, SearchQuestionRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTIONS.SEARCH_QUESTIONS(data.businessUnitId),
      ),
      data,
    );
  },

  // Create new question
  create: (data: CreateQuestionRequest) => {
    return apiClient.post<CreateQuestionResponse, CreateQuestionRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTIONS.CREATE(
          data.programId,
          data.businessUnit,
          data.divisionName,
        ),
      ),
      data,
    );
  },

  update: (data: UpdateQuestionRequest) => {
    return apiClient.put<UpdateQuestionResponse, UpdateQuestionRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.QUESTIONS.UPDATE(
          data.programId,
          data.businessUnit,
          data.divisionName,
          data.questionId,
        ),
      ),
      data,
    );
  },
};
